import { ReactComponent as InfoCircle } from "@/assets/svgs/icon-warning-circle.svg";
import Button from "@/components/Button/index";
import CardConfigure from "@/componentsDS/Modal/CardConfigure";
import Modal from "@/componentsDS/Modal/Modal";
import rem from "@/utils/rem";

const ExcludeAllEtrIssuance = ({ visible, hide, handleSubmit }) => {
	return (
		<Modal visible={visible} variant="small" close={hide}>
			<CardConfigure addHeaderClass="eap-modal__header">
				<CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__title__left">
									<div className={'card-configure__rounded-square card-configure__icon--error'}>
										<div className="tnc-modal__icon">
											<InfoCircle />
										</div>
									</div>
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										Exclude All Blockchain
									</div>
								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
				</CardConfigure.Header>
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						<div>
							<div className="etr-issuance-modal__content center">
								<p>
									By disabling all the blockchains, your organization will lose the capability to issue Electronic Transaction Records (ETRs).
								</p>
								<p>
									Please confirm that you wish to proceed.
								</p>
							</div>
						</div>
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
				<CardConfigure.Footer>
					<CardConfigure.Footer.Right>
						<div className="exclude-modal__confirmation_actions">
							<Button
								data-testid="etr-issuance-cancel"
								ghost
								round
								noborder
								reject
								submit={() => hide()}
								text="Cancel"
							/>
							<Button
								data-testid="etr-issuance-confirm"
								full
								round
								error
								submit={() => {
									handleSubmit()
									hide()
								}}
								text="Confirm"
							/>
						</div>
					</CardConfigure.Footer.Right>
				</CardConfigure.Footer>
			</CardConfigure>
		</Modal>
	);
};

export default ExcludeAllEtrIssuance;
